import RadioButton from "@frameworks/web/components/generic/RadioButton/radioButton";
import InputField from "@frameworks/web/components/generic/inputField";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { validityRadio, validityRadioEnum } from "../MutualFundConstant";
const Validity = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "mf-validity-radio equity-product-order" },
            React.createElement(Col, { lg: 12 }, validityRadio.map((item) => {
                return (React.createElement(RadioButton, { className: "common-radio-button validty-radio", name: "radio", list: item, selected: props.validity.presetValidity, onChange: (e) => {
                        {
                            props.setValidity({
                                presetValidity: e.target.value,
                                customValidity: "",
                            });
                        }
                    } }));
            })),
            props.validity.presetValidity == validityRadioEnum.CUSTOME && (React.createElement(Col, { lg: 8, className: "mt-3 custom-input" },
                React.createElement(InputField, { placeholderClassName: "", lable: false, className: "", placeholder: "₹ Enter in Months", onChange: (val) => {
                        {
                            props.setValidity(Object.assign(Object.assign({}, props.validity), { customValidity: val }));
                        }
                    }, prefix: React.createElement(React.Fragment, null) }))))));
};
export default Validity;
